<ng-container>
  <p
    *ngIf="
      deliveryDetails?.isDelivered || orderHeaderDeliveryDetails?.orderDelivered
    "
    data-cy="delivered-status-text"
  >
    Delivered
  </p>
  <p
    *ngIf="
      !deliveryDetails?.isDelivered &&
      !orderHeaderDeliveryDetails?.orderDelivered
    "
    data-cy="est-delivery-text"
  >
    Est. Delivery
  </p>
  <p *ngIf="orderHeaderDeliveryDetails?.orderDelivered">
    <span data-cy="delivery-date-text"
      >{{ orderHeaderDeliveryDetails?.deliveredDtm | date: 'M/d/yyyy' }} </span
    ><br />
    <span data-cy="delivery-time-text">{{
      orderHeaderDeliveryDetails?.deliveredDtm | date: 'shortTime'
    }}</span>
  </p>
  <p
    *ngIf="
      !deliveryDetails?.isDelivered &&
      !orderHeaderDeliveryDetails?.orderDelivered
    "
    data-cy="est-delivery-date-and-time-text"
  >
    {{ deliveryDetails?.start | date: 'M/d/yyyy':'GMT' }}<br />
    {{ deliveryDetails?.start | date: 'shortTime':'GMT' }} -
    {{ deliveryDetails?.end | date: 'shortTime':'GMT' }}
  </p>
</ng-container>
